import { createContext, type PropsWithChildren, useReducer } from 'react';

import { useInitializeSelectionLists } from './hooks/useInitializeSelectionLists';
import {
  type SelectionListAction,
  selectionListReducer,
} from './selection-list-reducer';
import type { GqlSelectionListKey, SelectionListState } from './types';

export type SelectionListContextState = {
  selectionLists: SelectionListState<GqlSelectionListKey> | null;
};

export type SelectionListContextType = {
  state: SelectionListContextState;
  dispatch: React.Dispatch<SelectionListAction>;
  isLoading: boolean;
};

export const SelectionListContext = createContext<
  SelectionListContextType | undefined
>(undefined);
export const SelectionListProvider = ({ children }: PropsWithChildren) => {
  const [state, dispatch] = useReducer(selectionListReducer, {
    selectionLists: null,
  });

  const { selectionListsError, selectionListsLoading } =
    useInitializeSelectionLists({ dispatch });

  if (selectionListsError) {
    console.error({ selectionListsError });
  }

  return (
    <SelectionListContext.Provider
      value={{
        state,
        dispatch,
        isLoading: selectionListsLoading,
      }}
    >
      {children}
    </SelectionListContext.Provider>
  );
};
